import { defineStore } from 'pinia'
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";

export const useStyleQuizStore = defineStore({
    id: 'styleQuiz',
    state: () => {
        return {
            photos: [],
            isLoading: false,
            rooms: [],
            furnitures: [],
        }
    },
    actions: {
        async fetchPhotos() {
            this.isLoading = true;
            axios.get(ApiHelper.getStyleQuizPhotosUrl(), {
                headers: authHelper.authHeader()
            }).then(result => {
                this.photos = result.data;
                this.isLoading = false;
            }).catch(errorResponse => {
                this.isLoading = false;
            })
        },
        async fetchRooms(type) {
            axios.get(ApiHelper.getAllRoomsUrl(type), {
                headers: authHelper.authHeader(),
            }).then(result => {
                this.rooms = result.data
            }).catch(errorResponse => {
            });
        },
        async fetchFurnitures() {
            axios.get(ApiHelper.getAllFurnituresUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                this.furnitures = result.data
            }).catch(errorResponse => {
            });
        },
    },
});
